import React, { useState, useEffect } from "react"

import { useRoiCalculatorData } from "../../utils/useRoiCalculatorData"
import ROICalc from "./classROICalc"

import { CalcTitle, Calculator, Content, ROIWrapper, } from "./styles/RoiCalculator.styled"
import ResultsContainer from "./components/ResultsContainer";
import TopSection from "./components/TopSection";
import ButtonSection from "./components/ButtonSection";
import LoadingAnimation from "../Form/LoadingState";

const ROICalculator = ({ openModal, isDetail }) => {
  const data = useRoiCalculatorData()
  const [employees, setEmployees] = useState(1000)
  const [formSubmitted, setFormSubmitted] = useState(false)
  const [loading, setLoading] = useState(true)
  const [showError, setShowError] = useState(false)

  const displayResults = (isDetail && formSubmitted) || !isDetail
  const error = "Please enter a valid number of employees."

  const calculator = new ROICalc(data, employees)

  const annualItSavings = calculator.calculateItSavings().formatted
  const ticketsPerEmp = calculator.calculateItSavings().ticketsPerEmp
  const annualProductivitySavings = calculator.calculateProductivitySavings().formatted
  const productivityHoursSaved = calculator.calculateProductivitySavings().hoursSaved
  const annualApprovalsSavings = calculator.calculateApprovalsSavings().formatted
  const total = calculator.calculateTotalSavings().formatted

  useEffect(() => {
    const sessionEmployees = sessionStorage.getItem("employees")
    const sessionSubmitted = sessionStorage.getItem("form-submitted")
    if (sessionEmployees !== null && sessionEmployees !== "") {
      setEmployees(sessionEmployees)
      if (sessionSubmitted === "true") {
        setFormSubmitted(true)
        setLoading(false)
      } else {
        setLoading(false)
      }
    } else {
      setEmployees(1000)
      setLoading(false)
    }
  }, [])

  const handleClick = (e) => {
    if (employees === "") {
      setShowError(true)
      e.preventDefault()
    } else {
      sessionStorage.setItem("employees", employees)
      openModal(1814)
      e.preventDefault()
    }
  }

  const calcTitle = (isDetail && formSubmitted) ? "Results Breakdown" : (isDetail && !formSubmitted) ? "Error" : "ROI Calculator"

  return (
    <ROIWrapper>
      <Content>
        <Calculator>
          {loading ? <LoadingAnimation background="white" /> 
            : <>
              <CalcTitle isDetail={isDetail}>{calcTitle}</CalcTitle>
              <TopSection 
                isDetail={isDetail} 
                employees={employees} 
                setEmployees={setEmployees} 
                formSubmitted={formSubmitted}
                error={error}
                showError={showError}
                setShowError={setShowError}
              />
              {displayResults &&
                <ResultsContainer 
                  annualApprovalsSavings={annualApprovalsSavings}
                  annualProductivitySavings={annualProductivitySavings}
                  annualItSavings={annualItSavings}
                  total={total}
                  isDetail={isDetail}
                  formSubmitted={formSubmitted}
                  prodHoursSaved={productivityHoursSaved}
                  ticketsPerEmp={ticketsPerEmp}
                  employees={employees}
                />
              }
              <ButtonSection 
                annualApprovalsSavings={annualApprovalsSavings}
                annualProductivitySavings={annualProductivitySavings}
                annualItSavings={annualItSavings}
                total={total}
                isDetail={isDetail}
                formSubmitted={formSubmitted}
                prodHoursSaved={productivityHoursSaved}
                ticketsPerEmp={ticketsPerEmp}
                handleClick={handleClick}
                employees={employees}
              />
            </>
          } 
        </Calculator>
      </Content>
    </ROIWrapper>
  )
}

export default ROICalculator
